import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import { TemplateType } from '../models/template';
import { ExportMetadataProfileEntry } from './export-metadata-profile-entry';
import { Endpoint } from './enums';

export class ExportMetadataProfileViewModel extends DrObject {
    model: Partial<ExportMetadataProfile>;

    constructor(value?: Partial<ExportMetadataProfile>) {
        super(DrObjectType.EXPORT_FIELDS);
        this.templateType = TemplateType.EXPORT_FIELDS;
        if (value) {
            this.model = value;
        }
    }
}

export class ExportMetadataProfile extends DrEntity {
    name: string;
    description: string;
    customMetadataFields: Array<any>;
    defaultProfile: boolean;
    entries: Array<ExportMetadataProfileEntry>;
    profileType: string;
    projectId: string;
    version: number;

    constructor(value?: Partial<ExportMetadataProfile>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    setAsDefaultRequestInfo(): [Endpoint, any] {
        return [Endpoint.projectManager_setExportMetadataProfile, {
            defaultProfile: true,
            entries: this.entries,
            name: this.name,
            profileHandle: this.handle,
            version: this.version,
            customMetadataFields: this.customMetadataFields
        }];
    }
}
